





























import { Prop, Component, Vue } from 'vue-property-decorator';
@Component
export default class FitDialog extends Vue {
  @Prop({ default: '' }) title!: string;
  @Prop({ default: '' }) content!: string;
  @Prop({ default: '' }) htmlContent!: string;
  @Prop({ default: '' }) align!: string;
  @Prop({ default: () => [] }) btns!: any[];

  get finalTitle() {
    if (this.title && !this.content && !this.htmlContent) {
      // 如果有标题 但是没有内容 则展示标题
      return '';
    }
    return this.title;
  }

  get isAlign() {
    return this.btns.length >= 3;
  }

  get btnAlignStyle() {
    return this.isAlign ? 'weui-dialog__ft__vertical' : '';
  }

  get finalContent() {
    if (this.title && !this.content && !this.htmlContent) {
      // 如果有标题 但是没有内容 则展示标题
      return this.title;
    }
    return this.content || this.htmlContent;
  }

  getBtnType(index) {
    if (this.isAlign) {
      return index < this.btns.length - 1 ? 'weui-dialog__btn_primary' : 'weui-dialog__btn_default';
    }
    return index === this.btns.length - 1 ? 'weui-dialog__btn_primary' : 'weui-dialog__btn_default';
  }

  handleClick(index: number) {
    // @ts-ignore
    if (
      this.btns &&
      this.btns[index] &&
      // @ts-ignore
      typeof this.btns[index].click === 'function'
    ) {
      // @ts-ignore
      this.btns[index].click();
    } else {
      this.$emit('click');
    }
  }
}
